module.exports = function getResource(label, vars = []) {
    let resources = {
        tlp: `Pssst! ${vars[0]} - here’s a secret offer you won’t want to miss.`
    };
    return resources[label];
};
